const initialValue = "";

export const testReducer = (state = initialValue, action) => {
  switch (action.type) {
    case "test":
      return action.payload;

    default:
      return state;
  }
};
